import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Programs from "./components/Programs";
import Gallery from "./components/Gallery";
import AboutUs from "./components/AboutUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Programs />
      <Gallery />
      <AboutUs />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
